import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";

createRoot(document.getElementById("root")).render(<App />);


 registerServiceWorker();

// Defer the install prompt event
let deferredPrompt;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;

  // Wait for DOM to be ready
  window.addEventListener("DOMContentLoaded", () => {
    const installBtn = document.getElementById("install-btn");
    if (installBtn) {
      installBtn.style.display = "block";

      installBtn.addEventListener("click", async () => {
        installBtn.style.display = "none";
        deferredPrompt.prompt();

        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }

        deferredPrompt = null;
      });
    }
  });
});
